import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import chatbotAPI from "../../api/chatbotAPI";

const getInitChatBot = createAsyncThunk(
  "GET_INIT_CHATBOT",
  async (_arg, { rejectWithValue }) => {
    try {
      const res = await chatbotAPI.getInitChatBot(_arg);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


const initialState = {
  status: false,
  first_question: null,
  listQuestions: null,
};

const chatbotSlice = createSlice({
  name: "chatbot",
  initialState,
  extraReducers: {
    [getInitChatBot.fulfilled]: (state, action) => {
      state.listQuestions = action.payload.questions;
      state.first_question = action.payload.first_question;
      state.status = action.payload.status;
    },
  },
});

const { reducer } = chatbotSlice;
export { getInitChatBot };
export default reducer;
